import { GraphCompanyList } from "../graph/GraphCompanyList";
import { GraphCompanyShow } from "../graph/GraphCompanyShow";

export default {
  list: GraphCompanyList,
  show: GraphCompanyShow,
};
